import { buildTextdomain } from 'react-gettext';
import Localization from './Localization';

const i18n = (global.i18n = global.i18n || {});
const DS_CORE_TEXT_DOMAIN = 'dealersite-core';

const translations = {
  en: buildTextdomain(require('./en.json')),
  fr: buildTextdomain(require('./fr.json')),
};

const coreLocalization = new Localization(translations, DS_CORE_TEXT_DOMAIN);
i18n.core = coreLocalization;

export { coreLocalization, translations, DS_CORE_TEXT_DOMAIN };
